/**
 * The /hive FAQ copy, in one place.
 *
 * `HivePageContent.tsx` renders these as the visible FAQ section and
 * `page.tsx` builds the FAQPage JSON-LD from the same array, so the schema and
 * the answers on screen cannot drift apart.
 *
 * It lives in its own module because `HivePageContent.tsx` is a Client
 * Component: importing a value across that boundary hands the server a client
 * reference, not the array.
 */
export const HIVE_FAQS = [
  [
    'How is Hive different from several chatbots?',
    'Separate chatbots answer within isolated sessions. Hive is designed so specialized agents read a shared customer state, coordinate task ownership, and hand work off with the conversation and rationale intact.',
  ],
  [
    'When should we choose Vector instead?',
    'Choose Vector for one lead-qualification use case. Choose Hive when work must coordinate across multiple agents or touchpoints. If you do not yet have 3+ touchpoints or 50+ daily interactions, Pixelmojo recommends starting smaller.',
  ],
  [
    'What exactly do we own?',
    'You own the application source, agent interfaces, workflow logic, integrations, database, customer data, deployment infrastructure, and documentation. Pixelmojo operates the proprietary orchestration, shared memory, models, scoring, and LLM infrastructure included in the platform fee.',
  ],
  [
    'What does the 12-week build include?',
    'Weeks 1–2 cover workflow discovery and architecture. Weeks 3–6 build 2–4 agents, memory, and integrations. Weeks 7–8 deploy in stages and train your team. Weeks 9–12 compare performance, iterate, document, and hand off.',
  ],
  [
    'How is sensitive data handled?',
    'The application and customer database run in infrastructure you control. Relevant conversation context is processed by Pixelmojo’s intelligence service. Before signing, request written specifics for retention, subprocessors, residency, access controls, audit logs, and incident response.',
  ],
  [
    'What happens if performance is weak?',
    'The plan is to establish a baseline in week one, review outcomes weekly, and conduct a mutual 90-day review. Guardrails include staged rollouts, monitoring, handoff logs, kill switches, rollback controls, and confidence-based human escalation.',
  ],
] as const
